var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgApproveOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 .842 1.402 1.9.213.288.34-.108 2.252-.713.018 2.362.002.358.34.113 2.24.746-1.374 1.921-.208.291.208.29 1.374 1.922-2.24.746-.34.113-.002.358-.018 2.362-2.251-.713-.341-.108-.213.287L8 15.157l-1.402-1.9-.213-.287-.34.107-2.252.714-.018-2.362-.002-.358-.34-.113-2.24-.746L2.566 8.29 2.775 8l-.208-.29-1.375-1.922 2.241-.746.34-.113.002-.358.018-2.362 2.251.713.341.108.213-.287L8 .843Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.3 5 7.8l.8-.8 1.7 1.7L11 5.5l.8.8-4.3 4Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgApproveOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/approve-outline.54763e2b35cfd5f4fe0165b744b6d6e6.svg";